// workspaceRename — THE ONE RENAME of a workspace from the shell: the
// workspace NAME card (pages/admin/workspace-settings.js, persona audit HO-2)
// and the new-account welcome's name field (components/OnboardingWorkStep.js,
// round 2 BLOCKER #5: a direct sign-up names its FIRST workspace instead of
// founding a second, empty one).
//
// The write is the server's PATCH /workspaces/:id `{ displayName }`
// (`sdk.updateWorkspace`, behind `requireWorkspaceRole(['owner','admin'])`).
// FENCE ON THE READ-BACK: a 200 whose stored name is not the one sent is a
// refusal too. After the server stored the name: the held record (through the
// ONE setter, so every reader of `root.workspace` repaints) and this
// workspace's rows in the switcher's lists.
//
// THE ONE NAME RULE: `displayName` first; the legacy `name` is frozen on older
// records (often "Default") — shared activeWorkspaceRecord.js
// workspaceDisplayName, restated here (FA204: self-contained export).
//
// THE PERSONAL ORG FOLLOWS (R2c-m1, elena-r2c 2026-10-26): a sign-up names its
// personal organization and personal workspace alike ("My workspace"), and the
// server renames the personal org with the workspace while the two share the
// old name (server WorkspaceMemberService.rename `mirrorPersonalOrg`). The org
// switcher lists the ORGANIZATION (`root.orgs` / `root.org`), so its rows take
// the new name here too, under the same rule: the workspace's own org, type
// `personal`, still carrying the old workspace name. A reload reads it from
// /auth/me.
//
// `this` is any shell element with `sdk` + `call`. → { ok: true, name } |
// { ok: false, reason: 'empty' | 'same' | 'unavailable' | 'failed' }.
export async function workspaceRename(root, wsId, raw) {
  const el = this
  const name = String(raw == null ? '' : raw)
    .replace(/\s+/g, ' ')
    .trim()
  if (!name) return { ok: false, reason: 'empty' }
  const held = root && root.workspace && typeof root.workspace === 'object' ? root.workspace : null
  const isThis = (w) => !!w && !!wsId && String(w.id || w._id || '') === String(wsId)
  if (isThis(held) && String(held.displayName || held.name || '') === name) {
    return { ok: false, reason: 'same' }
  }
  const sdk = el && el.sdk
  // The name being replaced and the workspace's org, read BEFORE the write.
  const listed = Array.isArray(root && root.workspaces) ? root.workspaces.find(isThis) : null
  const before = isThis(held) ? held : listed
  const oldName = before ? String(before.displayName || before.name || '') : ''
  const orgOf = (w) => (w ? String(w.org_id || w.organization || '') : '')
  const orgId =
    orgOf(before) || orgOf(listed) || (isThis(held) && root.org ? String(root.org.id || '') : '')
  if (!root || !wsId || !sdk || typeof sdk.updateWorkspace !== 'function') {
    return { ok: false, reason: 'unavailable' }
  }
  let stored = null
  try {
    const ws = await sdk.updateWorkspace(wsId, { displayName: name })
    stored = ws && typeof ws === 'object' ? ws.displayName : null
  } catch (err) {
    console.warn('[workspaceRename] save failed:', err && err.message)
    return { ok: false, reason: 'failed' }
  }
  if (stored !== name) {
    console.warn('[workspaceRename] save failed: the stored name is not the one sent')
    return { ok: false, reason: 'failed' }
  }
  const now = root.workspace
  if (isThis(now)) {
    el.call(
      'setActiveWorkspaceRecord',
      root,
      { ...now, displayName: name, name },
      { reason: 'admin:rename', sdk }
    )
  }
  const rename = (w) => (isThis(w) ? { ...w, displayName: name, name } : w)
  const byOrg = root.orgWorkspaces
  if (byOrg && typeof byOrg === 'object') {
    const next = {}
    let changed = false
    for (const k of Object.keys(byOrg)) {
      const list = byOrg[k]
      next[k] = Array.isArray(list) ? list.map(rename) : list
      if (Array.isArray(list) && list.some(isThis)) changed = true
    }
    if (changed) root.update({ orgWorkspaces: next })
  }
  if (Array.isArray(root.workspaces) && root.workspaces.some(isThis)) {
    root.update({ workspaces: root.workspaces.map(rename) })
  }
  const orgs = Array.isArray(root.orgs) ? root.orgs : []
  const orgRow = orgs.find((o) => o && String(o.id || o._id || '') === orgId)
  const isOrg = (o) => !!o && !!orgId && String(o.id || o._id || '') === orgId
  const personal = (orgRow && orgRow.type) || (isOrg(root.org) && root.org.type) || ''
  const follows = (o) => isOrg(o) && !!oldName && o.name === oldName && personal === 'personal'
  const retitle = (o) => (follows(o) ? { ...o, name } : o)
  const orgPatch = {}
  if (orgs.some(follows)) orgPatch.orgs = orgs.map(retitle)
  if (follows(root.org)) orgPatch.org = retitle(root.org)
  if (Object.keys(orgPatch).length) root.update(orgPatch)
  return { ok: true, name }
}
